import React, { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Crown } from "lucide-react";

// Founder-only: mark a show (one the founder is on) as network-fee free → even split.
export default function NoFeeToggle({ show, onChanged }) {
  const [busy, setBusy] = useState(false);
  const on = !!show?.no_network_fee;
  const flip = async () => {
    setBusy(true);
    try {
      await api.put(`/shows/${show.id}/network-fee`, { no_network_fee: !on });
      toast.success(!on ? "No network fee — hosts split 100% evenly" : "Network fee restored");
      onChanged();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div className="border border-[#F5A524]/40 bg-[#F5A524]/5 p-3" data-testid="no-fee-toggle">
      <label className={`flex items-start gap-2 text-sm ${show ? "cursor-pointer" : "opacity-60"}`}>
        <input type="checkbox" checked={on} disabled={!show || busy} onChange={flip} className="mt-0.5" data-testid="no-fee-checkbox" />
        <span>
          <span className="inline-flex items-center gap-1 font-display"><Crown size={12} className="text-[#F5A524]" /> Founder&apos;s show — no network fee</span>
          <span className="block text-xs text-[var(--ff-text-dim)]">{show ? "Hosts split 100% evenly (50/50 for two hosts), no showrunner bonus. Saves instantly." : "Save the show first, then edit it to turn this on."}</span>
        </span>
      </label>
    </div>
  );
}
